/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NatureFxLightningBIcon16Solid = forwardRef('NatureFxLightningBIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10 1.467C10 .52 8.806.103 8.217.845L2.235 8.378A1 1 0 0 0 3.018 10H6v4.533c0 .947 1.194 1.364 1.783.622l5.982-7.533A1 1 0 0 0 12.982 6H10V1.467Z" })));
});
